/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIFeedbackForm } from './APIFeedbackForm';
import {
    APIFeedbackFormFromJSON,
    APIFeedbackFormFromJSONTyped,
    APIFeedbackFormToJSON,
} from './APIFeedbackForm';

/**
 * 
 * @export
 * @interface APIPaginatedFeedbackFormList
 */
export interface APIPaginatedFeedbackFormList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedFeedbackFormList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedFeedbackFormList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedFeedbackFormList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIFeedbackForm>}
     * @memberof APIPaginatedFeedbackFormList
     */
    results: Array<APIFeedbackForm>;
}

/**
 * Check if a given object implements the APIPaginatedFeedbackFormList interface.
 */
export function instanceOfAPIPaginatedFeedbackFormList(value: object): value is APIPaginatedFeedbackFormList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedFeedbackFormListFromJSON(json: any): APIPaginatedFeedbackFormList {
    return APIPaginatedFeedbackFormListFromJSONTyped(json, false);
}

export function APIPaginatedFeedbackFormListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedFeedbackFormList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIFeedbackFormFromJSON)),
    };
}

export function APIPaginatedFeedbackFormListToJSON(value?: APIPaginatedFeedbackFormList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIFeedbackFormToJSON)),
    };
}

